import React, { useState } from 'react';
import PropTypes from 'prop-types';

// sushi
import Modal from 'sushiweb/Modal';
import grey from 'sushiweb/tokens/color/grey';
import H5 from 'sushiweb/Typography/Heading/H5';

// components
import CreateProgramModalContext from './CreateProgramModalContext';
import VoucherProgramForm from './ProgramForms/VoucherProgramForm/VoucherProgramForm';
import {
  GC_PLAN,
  GC_PLAN_TITLE,
  MEAL_PLAN,
} from './ProgramForms/common/Components/constants';
import AdhocProgramForm from './ProgramForms/AdhocProgramForm';

function CreateProgramModal({
  title,
  showModal,
  closeModal,
  modalClose,
  changeTitle,
  planData,
  planDataFlag,
  toStep,
}) {
  const [subtitle, setSubtitle] = useState('');
  const setModalSubtitle = text => {
    if (text !== '') setSubtitle(text);
  };

  const renderModalBody = render => {
    switch (render) {
      case MEAL_PLAN:
        return (
          <VoucherProgramForm planData={planData} planDataFlag={planDataFlag} />
        );
      case GC_PLAN:
        return (
          <AdhocProgramForm
            planData={planData}
            planDataFlag={planData.program_status}
            toStep={toStep}
          />
        );
      default:
        return <div>Plan Form not available</div>;
    }
  };
  let modalTitle = planDataFlag ? title : 'Create new meal plan';
  if (title === GC_PLAN) {
    modalTitle = <H5>{GC_PLAN_TITLE}</H5>;
  }
  // jsx
  return (
    <Modal
      title={(
        <>
          <span
            style={{
              fontSize: '20px',
              fontWeight: 500,
              color: grey.z800,
              padding: '0 6px',
            }}
          >
            {modalTitle}
            {' '}
          </span>
          {subtitle !== '' && (
            <>
              |
              <span
                style={{
                  fontSize: '16px',
                  fontWeight: 400,
                  color: grey.z600,
                  padding: '0 6px',
                }}
              >
                {subtitle}
              </span>
            </>
          )}
        </>
      )}
      visible={showModal}
      onClose={closeModal}
      overlayClickClose={title !== GC_PLAN}
      showCloseIcon
      isCentered
    >
      <CreateProgramModalContext.Provider
        value={{ closeModal, modalClose, changeTitle, setModalSubtitle }}
      >
        {/* need to to dismount the body on close */}
        {showModal && renderModalBody(title)}
      </CreateProgramModalContext.Provider>
    </Modal>
  );
}

CreateProgramModal.propTypes = {
  title: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalClose: PropTypes.object.isRequired,
  changeTitle: PropTypes.object.isRequired,
  planData: PropTypes.objectOf(PropTypes.any),
  planDataFlag: PropTypes.bool,
  toStep: PropTypes.number,
};

CreateProgramModal.defaultProps = {
  planData: {},
  planDataFlag: false,
  toStep: 1,
};

export default CreateProgramModal;
